
import CourseTitle from './CourseTitle.vue'
import CourseOverview from './CourseOverview.vue'
import CourseVideos from './CourseVideos.vue'
import CourseAuthors from './CourseAuthors.vue'
import CommentList from '@/components/Comments/CommentList.vue'
import LeaveComment from '@/components/Comments/LeaveComment.vue'
import CoursePrice from './CoursePrice.vue'
import CourseFeatures from './CourseFeatures.vue'
import CourseCategories from '../BookContent/BookCategories.vue'
import SimilarProducts from '../SimilarProducts/index.vue'
export default {
  components: {
    CourseTitle,
    CourseOverview,
    CourseVideos,
    CourseAuthors,
    CommentList,
    LeaveComment,
    CoursePrice,
    CourseFeatures,
    CourseCategories,
    SimilarProducts,
  },
  props: {
    product: {
      default: () => {},
    },
  },
}
